import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Українські підписи для `mat-paginator`.
 *
 * Material не локалізує пагінатор через `LOCALE_ID` — рядки зашиті англійською
 * в `MatPaginatorIntl`, тож єдиний спосіб їх перекласти — підмінити провайдер.
 * Реєструється глобально в `app.config.ts`, тому діє на всі пагінатори застосунку.
 */
@Injectable()
export class UkrainianPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Рядків на сторінці:';
  override nextPageLabel = 'Наступна сторінка';
  override previousPageLabel = 'Попередня сторінка';
  override firstPageLabel = 'Перша сторінка';
  override lastPageLabel = 'Остання сторінка';

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 з ${length}`;
    }

    const total = Math.max(length, 0);
    const startIndex = page * pageSize;
    // Якщо сторінка виходить за межі набору, кінець рахуємо арифметично —
    // так само, як це робить стандартна реалізація Material.
    const endIndex =
      startIndex < total ? Math.min(startIndex + pageSize, total) : startIndex + pageSize;

    return `${startIndex + 1} – ${endIndex} з ${total}`;
  };
}
